// Wall-clock and duration formatting for the Track Time timeline's drag
// interactions, which work in minutes-from-midnight. Mirrors the server's
// `time_tracking_duration` helper and its `%l:%M%P` clock, so a dragged
// label reads the same as the block it becomes.

export function clockLabel(minutesFromMidnight) {
  const hour24 = Math.floor(minutesFromMidnight / 60)
  const hour = hour24 % 12 === 0 ? 12 : hour24 % 12
  const meridiem = hour24 < 12 || hour24 === 24 ? "am" : "pm"
  return `${hour}:${pad(minutesFromMidnight % 60)}${meridiem}`
}

export function durationLabel(minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  if (!hours) return `${mins}m`
  return mins ? `${hours}h ${mins}m` : `${hours}h`
}

export function pad(value) {
  return String(value).padStart(2, "0")
}
